import { Injectable, Inject } from 'ng-metadata/core';
import {HttpService} from '../../../infra/httpRequest/http.service';
import {getInstitutionCode, getInstitutionId} from '../../../appConfig/appConfigForward';


@Injectable()
export class GtiService {
	private primaBaseUrl:any;
    private ilsServices:object={};
    private _instId = getInstitutionId();
    private _instCode = getInstitutionCode();
    private _globalTitleIndex = 121;
	constructor (private httpService: HttpService,
				 @Inject('$translate') private $translate,
				 @Inject('restBaseURLs') private restBaseURLs,
				 @Inject('$q') private $q: ng.IQService) {
					this.primaBaseUrl = restBaseURLs.gtiURL;
					this.ilsServices = {
						    '/gti': {
							'path': this.primaBaseUrl,        
							'method': 'GET'
						} }; 
	}

	private resquestInProgress:Object = {};
	    
    public isGtiInstitution(mmsid){
		let params = {
            mmsid: mmsid,
            instId: this._instId,
            globalTitleIndex:this._globalTitleIndex
        };
        
        return this.makeIlsRequest('/gti', params);
   }

    public getServices(){
        return this.ilsServices;
	}
	
	makeIlsRequest(serviceName: string, params: Object){
        if(!params){
            params= {};
        }
        let ngrsService = this.ilsServices[serviceName];
        this.resquestInProgress[serviceName] = true;

        return this.httpService.call(ngrsService.method, ngrsService.path, params)
            .then(
                (response)=> {
                    return this.ilsRequestSuccess(response);
                },
                (error)=>{
                    return this.ilsRequestFailure(error, serviceName, params);
                }
            ).finally( () =>
                this.resquestInProgress[serviceName] = false
            );
    }
    
	get requestInProgress(){
        return this.resquestInProgress || false;
    }

    private ilsRequestSuccess(response){
        return response;
    }

    private ilsRequestFailure(reason, serviceName, params) {
        console.error(reason, serviceName);
        return reason;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/gti.service.ts